<template>
  <div id="app" :style="{height: pagesHeight + 'px', width: pagesWidth + 'px'}">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      pagesWidth: 1260,//页面宽度
      pagesHeight: 600,//页面高度
    }
  },
  mounted() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize, true)
  },
  deactivated() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.pagesWidth = window.innerWidth
      this.pagesHeight = window.innerHeight
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/css/common.scss";
@import "@/assets/css/style.scss";
@import "@/assets/css/iconfont.scss";
</style>
